<template>
  <div style="width:100%" class="d-flex">
    <b-form-checkbox
      v-model="item.is_activo"
      :disabled="
        USER().rol === ROLES.SUPER ||
        USER().rol === ROLES.ADMIN ||
        USER().rol === ROLES.CALIFICACION
          ? false
          : true
      "
    >
    </b-form-checkbox>
    <div style="width: 100%;" @click="getEquiposInstitucion(item)">
      <img width="25" :src="item.foto" alt="" class="ml-1" />
      <span class="ml-1" style="text-transform: capitalize">{{
        item.nombre
      }}</span>

      <b-button
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION
        "
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="flat-danger"
        class="btn-icon"
        style="float:right;"
        size="sm"
        @click="eliminarInstitucion(item)"
      >
        <feather-icon icon="Trash2Icon" />
      </b-button>
      <b-button
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION
        "
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="flat"
        class="btn-icon"
        style="float:right;"
        size="sm"
        @click="updateInstitucion(item)"
      >
        <feather-icon icon="EditIcon" />
      </b-button>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { watch, computed } from '@vue/composition-api'
import {
  // BRow,
  // BCol,
  BFormCheckbox,
  // BFormInput,
  BButton,
  //   BFormGroup,
  // xx
} from 'bootstrap-vue'
import {
  // URL,
  USER,
  ROLES,
  // xx
} from '../../utils/variables'

export default {
  components: {
    // BRow,
    // BCol,
    BFormCheckbox,
    // BFormInput,
    BButton,
    // BFormGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    item: Object,
  },
  setup(props, { emit }) {
    const isActivo = computed(() => props.item.is_activo)
    function updateInstitucion(item) {
      emit('updateInstitucion', item)
    }
    function getEquiposInstitucion(item) {
      emit('getEquiposInstitucion', item)
    }
    function eliminarInstitucion(item) {
      emit('eliminarInstitucion', item)
    }

    watch(isActivo, estado => {
      emit('updateEstado', { item: props.item, is_activo: estado })
    })

    return {
      USER,
      ROLES,
      updateInstitucion,
      getEquiposInstitucion,
      eliminarInstitucion,
    }
  },
}
</script>

<style></style>
